import { connect } from 'react-redux';
import { routeTo } from 'redux-router-kit';

import { Profile, ToastNotification } from '@zapier/shared-entities';
import { RouterSelectors } from '@zapier/toolbox-redux-framework';

import * as AppDetails from 'app/entities/AppDetails';
import * as PartnerProfile from 'app/entities/PartnerProfile';
import {
  BASE_APP_URL,
  LEGACY_BUILDER_BASE_URL,
  ROLES,
} from 'app/developer-v3/constants';

import Invite from './Invite';

const getAppDetails = (state, inviteProps) => {
  const { title } = AppDetails.selectors.all.details(inviteProps.appId, state);

  return {
    appId: inviteProps.appId,
    appTitle: title,
    isCLIIntegration: inviteProps.isCLIIntegration,
  };
};

const submitProfile = (inviteProps, profileData) => async (
  dispatch,
  getState
) => {
  if (!inviteProps) {
    return null;
  }

  const { appTitle, appId, isCLIIntegration } = getAppDetails(
    getState(),
    inviteProps
  );

  await dispatch(
    PartnerProfile.actions.acceptAdminOrCollaboratorInvite(
      profileData,
      appId,
      isCLIIntegration ? 'cli' : 'wb'
    )
  );

  const entity = PartnerProfile.selectors.all.first(getState());

  if (PartnerProfile.selectors.isFailure(entity)) {
    return null;
  }

  dispatch(PartnerProfile.actions.resetCollection());
  dispatch(
    ToastNotification.actions.createSuccess(
      `You can now manage ${appTitle}'s Zapier Integration.`
    )
  );

  const routePath = isCLIIntegration
    ? `${BASE_APP_URL}/app/${appId}`
    : `${LEGACY_BUILDER_BASE_URL}/${
        isCLIIntegration ? 'cli-app' : 'app'
      }/${appId}`;

  dispatch(routeTo(routePath));

  return null;
};

const mapStateToProps = (state, ownProps) => {
  const currentProfile = Profile.selectors.all.currentProfile(state);
  const partnerProfile = PartnerProfile.selectors.all.first(state);

  const { title: appTitle, image: appImage } = AppDetails.selectors.all.details(
    ownProps.appId,
    state
  );
  const {
    first_name: firstName,
    job_title: jobTitle,
    last_name: lastName,
    roles,
  } = PartnerProfile.selectors.data(partnerProfile);

  return {
    appImage,
    appTitle,
    errorMessages: PartnerProfile.selectors.formError(partnerProfile),
    isSaving: PartnerProfile.selectors.isSaving(partnerProfile),
    firstName,
    invitationType:
      RouterSelectors.getQueryParam(state, 'type_of') ||
      RouterSelectors.getParam('role', state) ||
      ROLES.admin,
    jobTitle,
    lastName,
    roles,
    termsAccepted: Profile.selectors.hasAcceptedTerms(currentProfile),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  submitInviteModal(profileData) {
    dispatch(
      submitProfile(
        { isCLIIntegration: ownProps.isCLIIntegration, appId: ownProps.appId },
        profileData
      )
    );
  },
});

const InviteModalContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Invite);

export default InviteModalContainer;
